<template>
  <el-dialog
    custom-class="contract-iframe-dialog"
    :title="title"
    width="800px"
    @opened="openIframe"
    @close="closeLayer"
    :before-close="handleClose"
    :visible.sync="innerShow"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <div id="iframeBox">
      <div v-if="iframeLoading" class="iframeLoading">loading...</div>
    </div>
  </el-dialog>
</template>

<script>
import {getWxUserId} from '@/api/user';
export default {
  data() {
    return {
      title: '创建合同',
      innerShow: false,
      iframeLoading: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    show(newVal,oldVal){
      this.innerShow = newVal;
    }
  },
  mounted() {
    //监听message事件
    window.addEventListener("message", this.receiveMessage, false);
  },
  methods: {
    handleClose(done) {
      console.log('close dialog');
      this.$confirm('确认关闭？')
        .then(_ => {
          // 根据关闭页面处理
          // 审批页面关闭 代表合同已生成 绑定合同

          // 审批完成页面关闭 开始走流程
            done();
          })
          .catch(_ => {});
    },
    //回调函数
    receiveMessage(event) {
      // console.log('msgreceive',event);
      // console.log("接收到子页面的消息:", event.data);
      if (typeof event.data !== "object") {
        return;
      }
      if ( event.data.source !== "contractIframe" && event.data.source !== "sendMsgUpContract" && event.data.source !== "sendMsgUpProcess") {
        return;
      }
      if (typeof event.data.payload !== "object") {
        return;
      }


      if(event.data.source === "sendMsgUpContract"){
        // 绑定合同
        this.$emit("bindContract", event.data.payload, event.data.callbackData, event.data.processParams);
        return;
      }
      if(event.data.source === "sendMsgUpProcess"){
        // 流程开始
        this.$emit('startProcess', event.data.payload, event.data.callbackData, event.data.processParams);
        return;
      }

      console.log(event.data);
      this.$emit("complete", event.data.payload, event.data.callbackData, event.data.processParams);
      this.closeLayer();
    },
    openIframe() {
      const _this = this;
      // 需要等 vue 把dom节点渲染后执行
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 获取payload参数：配置发起合同的数据
      let payloadPromise = null
      _this.$emit('payload',(res) => {
        payloadPromise = res
      })

      Promise.all([
        // 获取用户信息
        getWxUserId(),
        // payload参数
        payloadPromise
      ]).then(ress => {
        if(!ress[0] || !ress[0].data) {
            throw new Error('获取用户数据失败')
        }
        let wxuserId = ress[0].data
        let payload = null;
        if(ress[1]) {
          payload = ress[1]
        }
        console.log(ress)
        this.$nextTick(() => {
          _this.iframeLoading = true;
          let iframeBox = document.querySelector("#iframeBox");
          // 因为 v-if 会删除dom，所以不用清空子节点。如果使用v-show需要手动清空子节点
          // 创建iframe节点，并设置onload函数
          let iframe = document.createElement("iframe");
          //iframe加载完毕后再发送消息，否则子页面接收不到message
          iframe.onload = function () {
            _this.iframeLoading = false;
            //iframe加载完立即发送一条消息
            let data = {
              source: "gangcai",
              payload: payload
            };
            iframe.contentWindow.postMessage(data, "*");
          };
          let src = process.env.VUE_APP_API_CAIWU + "/api/contract/view/create?source=gangcai&wxuid="+wxuserId
          if(_this.contractId) {
            src += '&contractId=' + _this.contractId
          }
          if(_this.spStatus) {
            src += '&spStatus=' + _this.spStatus
          }
          if(_this.tplModule) {
            src += '&tplModule=' + _this.tplModule
          }
          iframe.src = src;
          iframe.style.width = "100%";
          iframe.style.height = "100%";
          iframe.style.border = "0";
          // 把iframe节点添加到dom树上
          iframeBox.appendChild(iframe);
        });
      }).catch(err => {
        console.error(err)
        this.$message.error(err.message)
        this.closeLayer()
      }).finally(() => {
        loading.close()
      })
    },
    /**
     * 关闭合同iframe
     */
    closeLayer() {
      this.innerShow = false;
      this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped>
/deep/.contract-iframe-dialog {
  margin: 0px auto;
  margin-top: 10px !important;
}
/deep/.contract-iframe-dialog .el-dialog__body {
  padding: 0px;
}
#iframeBox {
  /* width: 400px;
            height: 400px; */
  /* width: 800px; */
  width: 100%;
  min-height: 600px;
  height: 90vh;
  position: relative;
  background-color: white;
}

.iframeLoading {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 20px;
  transform: translate(-50%, -50%);
}
</style>
